export const USER_RECEIVE = 'USER_RECEIVE';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_COMPLETE = 'LOGOUT_COMPLETE';
export const LOGOUT_FAILED = 'LOGOUT_FAILED';

export const USER_ACCEPT_TERMS_REQUEST = 'ACCEPT_TERMS_REQUEST';
export const USER_ACCEPT_TERMS_REQUEST_COMPLETE = 'ACCEPT_TERMS_COMPLETE';
export const USER_ACCEPT_TERMS_REQUEST_FAILED = 'ACCEPT_TERMS_FAILED';

export const USER_LIKE_SHOP_REQUEST = 'USER_LIKE_SHOP';

export const USER_DISLIKE_SHOP_REQUEST = 'USER_DISLIKE_SHOP';

export const USER_SHOP_PREFERENCE_ERROR = 'USER_SHOP_PREFERENCE_ERROR';
export const USER_SHOP_PREFERENCE_RECEIVE = 'USER_SHOP_PREFERENCE_RECEIVE';

const userReceive = me => {
  // Array used to add connected store/brands to Intercom
  const companies =
    me && me.analyticsAccess
      ? [
          ...(me.analyticsAccess.stores || []),
          ...(me.analyticsAccess.brands || []),
        ].map(company => ({
          id: company.id,
          name: company.name,
        }))
      : undefined;

  return {
    type: USER_RECEIVE,
    me: me ? { ...me, companies } : undefined,
  };
};

export const logoutRequest = message => ({
  type: LOGOUT_REQUEST,
  message,
});

export const logoutComplete = () => ({
  type: LOGOUT_COMPLETE,
});

export const logoutFailed = error => ({
  type: LOGOUT_FAILED,
  error,
});

export const acceptTermsRequest = policyTypes => ({
  type: USER_ACCEPT_TERMS_REQUEST,
  policyTypes,
});

const acceptTermsComplete = () => ({
  type: USER_ACCEPT_TERMS_REQUEST_COMPLETE,
});

const acceptTermsFailed = () => ({
  type: USER_ACCEPT_TERMS_REQUEST_FAILED,
});

export const likeShop = shopId => ({
  type: USER_LIKE_SHOP_REQUEST,
  shopId,
});

export const dislikeShop = shopId => ({
  type: USER_DISLIKE_SHOP_REQUEST,
  shopId,
});

export const shopPreferenceError = () => ({
  type: USER_SHOP_PREFERENCE_ERROR,
});

export const receiveShopPreference = shopPreferenceState => ({
  type: USER_SHOP_PREFERENCE_RECEIVE,
  shopPreferenceState,
});

export default {
  userReceive,
  logoutRequest,
  acceptTermsRequest,
  acceptTermsComplete,
  acceptTermsFailed,
};
